import React, { Component } from "react";
import Info from "./Info";
import "./InfoPanel.scss";

export default class InfoPanel extends Component {
    getNumberOfBookmars = () => {
        if (!this.props.bookmarksSelected) return 0;
        if (!this.props.bookmarks) return 0;
        if (this.props.bookmarksSelected === "my") {
            if (
                !this.props.bookmarks.my_bookmarks ||
                this.props.bookmarks.my_bookmarks.length === 0
            )
                return 0;
            return this.props.bookmarks.my_bookmarks.length;
        }
        if (
            !this.props.bookmarks.shared ||
            this.props.bookmarks.shared.length === 0
        )
            return 0;
        for (const share of this.props.bookmarks.shared) {
            if (share.username === this.props.bookmarksSelected) {
                if (!share.bookmarks) return 0;
                return share.bookmarks.length;
            }
        }
        return 0;
    };

    getAveragePrice = () => {
        if (!this.props.bookmarksSelected) return 0;
        if (!this.props.bookmarks) return 0;
        if (this.props.bookmarksSelected === "my") {
            if (
                !this.props.bookmarks.my_bookmarks ||
                this.props.bookmarks.my_bookmarks.length === 0
            )
                return 0;
            let aux = 0;
            let count = 0;
            this.props.bookmarks.my_bookmarks.forEach(bookmark => {
                if (bookmark.price > 0) {
                    aux += bookmark.price;
                    count++;
                }
            });
            return aux / count;
        }
        if (
            !this.props.bookmarks.shared ||
            this.props.bookmarks.shared.length === 0
        )
            return 0;
        for (const share of this.props.bookmarks.shared) {
            if (share.username === this.props.bookmarksSelected) {
                if (!share.bookmarks) return 0;
                let aux = 0;
                let count = 0;
                share.bookmarks.forEach(bookmark => {
                    if (bookmark.price > 0) {
                        aux += bookmark.price;
                        count++;
                    }
                });
                return aux / count;
            }
        }
        return 0
    };


    render() {
        return (
            <div className="col mt-lg-3 mt-md-3 mt-sm-1 mt-1 mb-1 pt-2">
                <Info
                    title="Total Bookmarks"
                    data={ this.getNumberOfBookmars() }
                    title2="Average Price"
                    data2={"$" + this.getAveragePrice().toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) }
                />
            </div>
        );
    }
}
